import { render, staticRenderFns } from "./PrintDispatchSummary.vue?vue&type=template&id=56868e1a&scoped=true"
import script from "./PrintDispatchSummary.vue?vue&type=script&lang=js"
export * from "./PrintDispatchSummary.vue?vue&type=script&lang=js"
import style0 from "./PrintDispatchSummary.vue?vue&type=style&index=0&id=56868e1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56868e1a",
  null
  
)

export default component.exports